// extracted by mini-css-extract-plugin
export var cardIcon = "_5a-4";
export var checkboxCard = "_5a-0";
export var checkboxCardSelected = "_5a-3";
export var disabled = "_5a-1";
export var outerBorder = "_5a-2";
export var spacerMedium = "_5a-7";
export var spacerSmall = "_5a-6";
export var spacerXsmall = "_5a-5";